module.exports = __webpack_public_path__ + "static/media/shinyAmulet.e771fc5f.jpg";